import { render, staticRenderFns } from "./ModuleSelectorOne.vue?vue&type=template&id=edd06a58&scoped=true"
import script from "./ModuleSelectorOne.vue?vue&type=script&lang=js"
export * from "./ModuleSelectorOne.vue?vue&type=script&lang=js"
import style0 from "./ModuleSelectorOne.vue?vue&type=style&index=0&id=edd06a58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd06a58",
  null
  
)

export default component.exports